import { useCallback, useState } from 'react';
import { withChange } from '../components/notification-settings/settings-changes';
import type {
  NotificationField,
  NotificationSettingsChanges,
} from '../types/notification-settings';

export interface SettingsChangesState {
  changes: NotificationSettingsChanges;
  changeCount: number;
  setChange: (type: string, field: NotificationField, value: boolean | string | null) => void;
  clearChanges: () => void;
}

export function useSettingsChanges(): SettingsChangesState {
  const [changes, setChanges] = useState<NotificationSettingsChanges>({});
  const setChange = useCallback(
    (type: string, field: NotificationField, value: boolean | string | null) =>
      setChanges((current) => withChange(current, type, field, value)),
    [],
  );
  const clearChanges = useCallback(() => setChanges({}), []);
  const changeCount = Object.values(changes).reduce(
    (count, fields) => count + Object.keys(fields).length,
    0,
  );
  return { changes, changeCount, setChange, clearChanges };
}
